import { render, staticRenderFns } from "./phrase_select.vue?vue&type=template&id=a9a895ce&"
import script from "./phrase_select.vue?vue&type=script&lang=js&"
export * from "./phrase_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports